import React, { useRef, useEffect } from 'react'
import SALink from 'components/SALink'
import useIntersectionObserver from 'hooks/intersectionObserver'
import Image from 'components/Artworks/ImageWithActions'
import ABTestArtworkText from 'components/Artworks/ABTestArtworkText'
import DataLayer, { Impression } from 'lib/dataLayer'
import AlgoliaEvents from 'lib/algoliaEvents'
import { getDataLayerItemVariant, capitalizeString } from 'lib/helpers'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import { ArtworkContainer } from './styles'

type Props = Record<string, any>

// Renders a carousel of additional artworks by the artist.
const ABTestArtwork = (props: Props) => {
  const ecommerceRef: Record<string, any> = useRef(null)
  const {
    artistName,
    artworkId,
    baseImageUrl,
    category,
    clickArtwork,
    dataApi,
    dataList,
    dataListId,
    dataListName,
    dataPosition,
    originalStatus,
    price,
    productUrl,
    sku,
    subject,
    styles,
    title,
    algoliaSearchIndex,
    algoliaUserToken,
    algoliaQueryID,
    userID,
  } = props
  const capitalizedArtistName = capitalizeString(artistName)
  const { hasViewed } = useIntersectionObserver(ecommerceRef)

  useEffect(() => {
    if (hasViewed) {
      // This is the new dataLayer event for GA4
      const impression: Impression = {
        // Strip trailing `s` - Paintings => Painting
        // Change Mixed Media => Mixedmedia
        item_category: category.replace(/s$/, '').replace(/\sM/, 'm'),
        item_id: sku,
        item_art_id: artworkId,
        // item_list_name: dataList,
        item_name: title,
        item_brand: artistName,
        item_variant: getDataLayerItemVariant(sku),
        index: dataPosition,
        affiliation: 'Online Store',
        price: convertFromCentsToDollars(price) || 0,
        quantity: 1,
        original_availability: originalStatus,
      }
      DataLayer.addImpressionEvent(impression, dataListId, dataListName)
      AlgoliaEvents.addImpressionEvent(
        artworkId,
        algoliaSearchIndex,
        algoliaUserToken,
        algoliaQueryID,
        userID
      )
    }
  }, [hasViewed])

  return (
    <ArtworkContainer ref={ecommerceRef}>
      <Image
        artistName={capitalizedArtistName}
        artworkId={artworkId}
        category={category}
        dataApi={dataApi}
        dataList={dataList}
        dataListId={dataListId}
        dataListName={dataListName}
        dataPosition={dataPosition}
        href={productUrl}
        onClick={clickArtwork}
        originalStatus={originalStatus}
        price={price}
        sku={sku}
        src={baseImageUrl || ''}
        subject={subject}
        styles={styles}
        title={title}
      />

      {dataApi === 'visii' && (
        <SALink
          data-type='visii-button'
          href={`/vsearch?search=category:${category || ''}&selected=${artworkId || ''}`}
          target='_blank'
          rel='noopener noreferrer'
          onClick={() => {
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'see more like this',
              })
            }
          }}
        >
          <p className='defaultTypographyCtaSmall'>SEE MORE LIKE THIS</p>
        </SALink>
      )}

      <ABTestArtworkText {...props} productPage={productUrl} clickArtwork={clickArtwork} />
    </ArtworkContainer>
  )
}

export default ABTestArtwork
